import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { LoginService } from '../../login/login.service';
// import { LoginSettings } from '../../login/LoginSetting.model';
import { Report } from '../models/report.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportDefinition } from '../models/report-definition.model';
import { ReportLegendComponent } from '../report-legend/report-legend.component';
import { ReportOptionsHowToComponent } from './report-options-how-to.component';

import { CheckForErrorsMessageComponent } from '../../../shared-components/guards/check-for-errors/check-for-errors-message/check-for-errors-message.component';

// import { AddReportFolderComponent } from './add-folder/add-folder.component';
// import { DeleteReportFolderComponent } from './delete-folder/delete-folder.component';

@AutoUnsubscribe()
@Component({
    selector: 'reportOptions',
    templateUrl: './report-options.component.html',
    styleUrls: ['./report-options.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class ReportOptionsComponent implements OnInit, OnDestroy {

    thisDialogRef: MatDialogRef<ReportOptionsComponent>;
    reportLegendDialogRef: MatDialogRef<ReportLegendComponent>;
    selectedReport: Report;
    reportName: string;
    howToDialogRef: MatDialogRef<ReportOptionsHowToComponent>;

    reportDefinitions: ReportDefinition[] = [];
    userHasDistrictPermissions: boolean;
    isDistrictDefinitions: boolean;
    inDebugMode: boolean;
    saveAllChecked: boolean;
    hideAllChecked: boolean;
    // cancelCloseLabel: string;
    isFromMenu: boolean;
    isDirty: boolean;

    previouslySavedUserDefinitions: number[]; // existing ParameterValue.IDs
    previouslySavedDistrictDefinitions: number[]; // existing ParameterValue.IDs

    // reportFolders: ReportFolder[];

    // addReportFolderDialogRef: MatDialogRef<AddReportFolderComponent>;
    // deleteReportFolderDialogRef: MatDialogRef<DeleteReportFolderComponent>;

    // reportFolderChanged = false;

    // addReportFolderDialog: MatDialog;

    constructor(
        reportOptionsDialogRef: MatDialogRef<ReportOptionsComponent>,
        private reportLegendDialog: MatDialog,
        private howToDialog:  MatDialog,
        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent
        private loginService: LoginService,
        private dialog: MatDialog,
        //  private checkForErrorsGuard: CheckForErrorsGuard,

        // private addReportFolderDialog: MatDialog,
        // private deleteReportFolderDialog: MatDialog,

    ) {

        this.thisDialogRef = reportOptionsDialogRef;
    }

    ngOnInit() {
        this.isDirty = false;
        this.inDebugMode = this.reportService.inDebugMode;
        this.selectedReport = this.reportService.SelectedReport;
        this.reportName = this.selectedReport.Name;
        this.userHasDistrictPermissions = this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions;
        this.isDistrictDefinitions = false; // defaults to personal
        this.isFromMenu = this.reportService.isFromMenu;
        // if (this.reportService.inDebugMode) {
        //     console.log('isFromMenu = ');
        //     console.log(this.isFromMenu);
        // }

        // REMOVE AFTER TESTING
        // this.selectedReport.Parameters.length = 0;


        // need to populate the report parameters if coming from actions menu instead of report parameters component
        if (this.isFromMenu) {
            this.getDefaultReportParametersForUser();
        }
        else {
            // we already have the parameters so go get the definitions
            this.getReportDefinitions();
        }
    }
    ngOnDestroy() { }

    getDefaultReportParametersForUser() {
        this.reportService.getReportParameters(-1, this.selectedReport, false).subscribe(selectedReport => {

            // if (this.inDebugMode) {
            //     console.log('In getDefaultReportParametersForUser()');
            //     console.log(selectedReport);
            // }

            this.getReportDefinitions();

            for (let i = 0; i < this.selectedReport.Parameters.length; i++) {

                // if (this.selectedReport.Parameters[i].ParameterReportDefinition.HasParameterValueDefined
                //   && this.selectedReport.Parameters[i].ParameterReportDefinition.IsSystem == false
                // ) {
                //   this.selectedReport.Parameters[i].SetBackgroundColorForSavedDefinition = true;
                // }

                // handle bit parameters if saved definition to convert from string

                if (this.selectedReport.Parameters[i].DataType == 'bit') {
                    if (this.selectedReport.Parameters[i].ParameterReportDefinition.Value == '1') {
                        this.selectedReport.Parameters[i].ParameterReportDefinition.Value = true;
                        this.selectedReport.Parameters[i].Value = true;
                    }
                    else {
                        this.selectedReport.Parameters[i].ParameterReportDefinition.Value = false;
                        this.selectedReport.Parameters[i].Value = false;
                    }

                }
            }

            // this.reportService.SelectedReport = selectedReport;
            this.selectedReport = selectedReport;
            this.selectedReport.IsDistrictReportDefinitions = false;
        });


    }


    // cancelClick() {
    //     this.thisDialogRef.close(this.isDirty);
    // }

    closeClick() {

        const parameterDefinitions: ReportDefinition[] = this.getUnsavedChanges();


        if (this.isDirty) {

            const dialog = this.dialog.open(CheckForErrorsMessageComponent, {
                disableClose: true,
                data: {
                    errors: []
                }
            });

            dialog.componentInstance.dialogBox = dialog;
            dialog.afterClosed().subscribe(result => {
                console.log(result);
                switch (result) {
                    case 1: { // save and continue
                        this.reportService.saveReportOptions(parameterDefinitions, true).subscribe(saveWasSuccessful => {

                            // if (this.reportService.inDebugMode) {
                            //     console.log('saveWasSuccessful: ' + saveWasSuccessful);
                            //     console.log(parameterDefinitions);
                            // }

                            // close after save
                            this.thisDialogRef.close(true);

                        });
                        break;
                    }
                    case 0: { // continue without save
                        this.thisDialogRef.close(false);
                        break;
                    }
                    case -1: { // cancel
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });

        }
        else { // no unsaved changes
            this.thisDialogRef.close(false);
        }
    }




    // cancelClick() {
    //     switch (this.selectedTab) {
    //       case 'Event': {
    //         if (this.eventTab.formIsDirty) {
    //           const dialog = this.dialog.open(CheckForErrorsMessageComponent, {
    //             disableClose: true,
    //             data: {
    //               errors: []
    //             }
    //           });
    //           dialog.componentInstance.dialogBox = dialog;
    //           dialog.afterClosed().subscribe(result => {

    //             switch (result) {
    //               case 1: { // save and continue
    //                 if (this.validateTab()) {
    //                   this.saveBehaviorEvent(true);
    //                 }
    //                 break;
    //               }
    //               case 0: { // continue without save
    //                 this.dialogRef.close(null);
    //                 break;
    //               }
    //               case -1: { // cancel
    //                 break;
    //               }
    //               default: {
    //                 break;
    //               }
    //             }
    //           });
    //         }
    //         else {
    //           this.dialogRef.close(null);
    //         }
    //         break;
    //       }
    //       default: {
    //         this.dialogRef.close(this.behaviorEvent);
    //         break;
    //       }
    //     }
    //   }

    saveAllChanged(isChecked: boolean) {
        // if (this.reportService.inDebugMode) {
        //     console.log(isChecked);
        // }

        for (let i = 0; i < this.reportDefinitions.length; i++) {
            if (!this.isDisabled(this.reportDefinitions[i])) {
                this.reportDefinitions[i].SaveChecked = isChecked;
                this.saveChecked(this.reportDefinitions[i]);
            }
        }

    }

    hideAllChanged(isChecked: boolean) {
        // if (this.reportService.inDebugMode) {
        //     console.log(isChecked);
        // }

        for (let i = 0; i < this.reportDefinitions.length; i++) {
            if (!this.isDisabled(this.reportDefinitions[i])) {
                this.reportDefinitions[i].HideChecked = isChecked;
                this.hideChecked(this.reportDefinitions[i]);
            }
        }

    }

    getReportDefinitions() {
        // if (this.reportService.inDebugMode) {
        //     console.log(this.selectedReport);
        // }

        // this.cancelCloseLabel = 'Close';

        this.selectedReport.IsDistrictReportDefinitions = this.isDistrictDefinitions;

        this.reportService.getReportDefinitions(true).subscribe(reportDefs => {

            // if (this.reportService.inDebugMode) {
            //     console.log(reportDefs);
            // }


            this.reportDefinitions = reportDefs;

            for (let i = 0; i < this.reportDefinitions.length; i++) {

                // if HasParameterValueDefined we also need to uncheck any user level defs saved if running for district
                if (this.reportDefinitions[i].HasParameterValueDefined == 1 && (!this.isDistrictDefinitions || this.reportDefinitions[i].IsDistrictDefinedParameter)) {
                    if (this.reportDefinitions[i].CanSave) {
                        this.reportDefinitions[i].SaveChecked = true;
                    }
                    if (this.reportDefinitions[i].IsHidden) {
                        this.reportDefinitions[i].HideChecked = true;
                    }
                }
                if (!this.reportDefinitions[i].SaveChecked) {
                    this.reportDefinitions[i].SaveChecked = false;
                }
                this.reportDefinitions[i].CanSave = this.reportDefinitions[i].SaveChecked;
                if (!this.isDisabled(this.reportDefinitions[i])) {
                    this.reportDefinitions[i].IsUserDefinedParameter = !this.isDistrictDefinitions;
                    this.reportDefinitions[i].IsDistrictDefinedParameter = this.isDistrictDefinitions;

                    if (this.reportDefinitions[i].IsUserDefinedParameter) {
                        this.reportDefinitions[i].Login_ID = this.reportService.login_ID;
                    }
                    else {
                        this.reportDefinitions[i].Login_ID = -1;
                    }
                }
                this.setBackgroundColorForSavedDefinition(this.reportDefinitions[i]);

                // set the value coming from the report parameters page

                for (let p = 0; p < this.selectedReport.Parameters.length; p++) {
                    // if (this.selectedReport.Parameters[p].ParameterName == '@' + this.reportDefinitions[i].ParameterName)
                    if (this.selectedReport.Parameters[p].ParameterName == '@' + this.reportDefinitions[i].ParameterName) {

                        // since the saved definition value may be different than the current parameter value we need to check for isDirty even if they never check any checkboxes
                        if (!this.isDirty) {

                            // todo: we may need to handle the _Y/_N bit parameters here as well

                            if (this.isDistrictDefinitions && this.reportDefinitions[i].IsDistrictDefinedParameter) {
                                if (this.reportDefinitions[i].HasParameterValueDefined && this.reportDefinitions[i].Value != this.selectedReport.Parameters[p].Value) {
                                    this.isDirty = true;
                                }
                            }

                        }

                        this.reportDefinitions[i].Value = this.selectedReport.Parameters[p].Value;
                        // if (this.inDebugMode) {
                        //     console.log('Setting definition value');
                        //     console.log(this.selectedReport.Parameters[p]);
                        //     console.log(this.reportDefinitions[i]);
                        // }
                        break; // continue;
                    }
                }

            }


            // if (this.reportService.inDebugMode) {
            //     console.log(this.reportDefinitions);
            // }


        });

    }

    saveChecked(reportDef: ReportDefinition) {
        reportDef.CanSave = reportDef.SaveChecked;

        if (this.isDistrictDefinitions) {
            reportDef.IsDistrictDefinedParameter = true;
            reportDef.IsUserDefinedParameter = false;
        }
        else {
            reportDef.IsDistrictDefinedParameter = false;
            reportDef.IsUserDefinedParameter = true;
        }


        // we need to save any parameters marked to hide

        if (reportDef.HideChecked) {
            reportDef.SaveChecked = true;
            this.isDisabled(reportDef);
            // this.hideChecked(reportDef);
        }

        this.setBackgroundColorForSavedDefinition(reportDef);

        // if (this.reportService.inDebugMode) {
        //     console.log(reportDef);
        // }

    }

    hideChecked(reportDef: ReportDefinition) {
        reportDef.IsHidden = reportDef.HideChecked;

        if (this.isDistrictDefinitions) {
            reportDef.IsDistrictDefinedParameter = true;
            reportDef.IsUserDefinedParameter = false;
        }
        else {
            reportDef.IsDistrictDefinedParameter = false;
            reportDef.IsUserDefinedParameter = true;
        }

        // we need to save any parameters marked to hide

        if (reportDef.HideChecked) {
            reportDef.SaveChecked = true;
            this.saveChecked(reportDef);
        }

        this.setBackgroundColorForSavedDefinition(reportDef);

        // if (this.reportService.inDebugMode) {
        //     console.log(reportDef);
        // }

    }

    saveReportOptionsClick() {
        const parameterDefinitions: ReportDefinition[] = this.getUnsavedChanges();

        if (this.inDebugMode) {
            console.log('Saving...');
            console.log(parameterDefinitions);
        }

        // need to save any changes
        this.reportService.saveReportOptions(parameterDefinitions, true).subscribe(saveWasSuccessful => {

            // if (this.reportService.inDebugMode) {
            //     console.log('saveWasSuccessful: ' + saveWasSuccessful);
            //     console.log(parameterDefinitions);
            // }

            // close after save
            this.thisDialogRef.close(true);

        });

        // if (this.isDirty) {

        //     // need to save any changes
        //     this.reportService.saveReportOptions(parameterDefinitions, true).subscribe(saveWasSuccessful => {

        //         // if (this.reportService.inDebugMode) {
        //         //     console.log('saveWasSuccessful: ' + saveWasSuccessful);
        //         //     console.log(parameterDefinitions);
        //         // }

        //         // close after save
        //         this.thisDialogRef.close(this.isDirty);

        //     });

        // }
        // else { // NO need to save any changes
        //     this.thisDialogRef.close(this.isDirty);
        // }

    }

    // saveReportOptionsClick() {

    //     const parameterDefinitions: ReportDefinition[] = [];

    //     // if (this.reportService.inDebugMode) {
    //     //     console.log(this.reportDefinitions);
    //     // }

    //     for (let i = 0; i < this.reportDefinitions.length; i++) {

    //         let thisReportDef: ReportDefinition;
    //         thisReportDef = this.reportDefinitions[i];

    //         // handle bit parameters since we need them as 1 or 0 in database but boolean in typescript
    //         if (thisReportDef.DataType == 'bit') {
    //             if (thisReportDef.Value == true) {
    //                 thisReportDef.Value = '1';
    //             }
    //             else {
    //                 thisReportDef.Value = '0';
    //             }
    //         }

    //         if (
    //             //  we want to ignore any system parameters
    //             !(thisReportDef.IsSystem && !thisReportDef.AllowUserSaveParameter && !thisReportDef.AllowUserHideParameter)

    //             //  we want to ignore any parameters that don't have a saved definition and have no options checked
    //             // && !(thisReportDef.HasReportDefinition == 0 && !thisReportDef.CanSave && !thisReportDef.IsHidden)
    //             && !(thisReportDef.HasReportDefinition == 0 && !thisReportDef.SaveChecked && !thisReportDef.IsHidden)

    //         ) {
    //             if (thisReportDef.SaveChecked) {
    //                 thisReportDef.CanSave = true;
    //             }
    //             else {
    //                 thisReportDef.CanSave = false;
    //             }

    //             if (thisReportDef.HideChecked) {
    //                 thisReportDef.IsHidden = true;
    //             }
    //             else {
    //                 thisReportDef.IsHidden = false;
    //             }

    //             // now we need to determine if this component needs to be marked as isDirty

    //             // first we will look at new definitions to be saved

    //             if (!this.isDirty && thisReportDef.HasParameterValueDefined == 0 && thisReportDef.SaveChecked) {

    //                 if (this.isDistrictDefinitions && thisReportDef.IsDistrictDefinedParameter) {
    //                     this.isDirty = true;
    //                 }
    //                 else if (!this.isDistrictDefinitions && thisReportDef.IsUserDefinedParameter) {
    //                     this.isDirty = true;
    //                 }
    //             }

    //             // now we will look at existing definitions that have been unchecked to save

    //             if (!this.isDirty && thisReportDef.HasParameterValueDefined == 1 && !thisReportDef.SaveChecked) {

    //                 if (this.isDistrictDefinitions && thisReportDef.IsDistrictDefinedParameter) {
    //                     this.isDirty = true;
    //                 }
    //                 else if (!this.isDistrictDefinitions && thisReportDef.IsUserDefinedParameter) {
    //                     this.isDirty = true;
    //                 }
    //             }




    //             // // set the value coming from the report parameters page
    //             // if (thisReportDef.CanSave) {
    //             //     for (let p = 0; p < this.selectedReport.Parameters.length; p++) {
    //             //         if (this.selectedReport.Parameters[p].ParameterReportDefinition.ParameterName_ID == thisReportDef.ParameterName_ID) {
    //             //             thisReportDef.Value = this.selectedReport.Parameters[p].Value;
    //             //         }
    //             //     }
    //             // }


    //             // handle district parameters
    //             // this.selectedReport.IsDistrictReportDefinitions
    //             if (this.isDistrictDefinitions && thisReportDef.IsDistrictDefinedParameter) {
    //                 parameterDefinitions.push(thisReportDef);
    //             }

    //             //  handle user parameter definitions
    //             // this.selectedReport.IsDistrictReportDefinitions
    //             if (!this.selectedReport.IsDistrictReportDefinitions && !thisReportDef.IsDistrictDefinedParameter && (thisReportDef.SaveChecked || thisReportDef.HideChecked)) {
    //                 thisReportDef.Login_ID = this.reportService.login_ID;
    //                 parameterDefinitions.push(thisReportDef);
    //             }

    //         }

    //     }

    //     // if (this.reportService.inDebugMode) {
    //     //     console.log(parameterDefinitions);
    //     // }

    //     if (this.isDirty) {

    //         // need to save any changes
    //         this.reportService.saveReportOptions(parameterDefinitions, true).subscribe(saveWasSuccessful => {

    //             // if (this.reportService.inDebugMode) {
    //             //     console.log('saveWasSuccessful: ' + saveWasSuccessful);
    //             //     console.log(parameterDefinitions);
    //             // }

    //             // close after save
    //             this.thisDialogRef.close(this.isDirty);

    //         });

    //     }
    //     else { // NO need to save any changes
    //         this.thisDialogRef.close(this.isDirty);
    //     }



    // }


    getUnsavedChanges(): ReportDefinition[] {

        this.isDirty = false;

        const parameterDefinitions: ReportDefinition[] = [];

        // if (this.reportService.inDebugMode) {
        //     console.log(this.reportDefinitions);
        // }

        for (let i = 0; i < this.reportDefinitions.length; i++) {

            let thisReportDef: ReportDefinition;
            thisReportDef = this.reportDefinitions[i];

            // handle bit parameters since we need them as 1 or 0 in database but boolean in typescript
            if (thisReportDef.DataType == 'bit') {
                if (thisReportDef.Value == true) {
                    thisReportDef.Value = '1';
                }
                else {
                    thisReportDef.Value = '0';
                }
            }

            if (
                //  we want to ignore any system parameters
                !(thisReportDef.IsSystem && !thisReportDef.AllowUserSaveParameter && !thisReportDef.AllowUserHideParameter)

                //  we want to ignore any parameters that don't have a saved definition and have no options checked
                // && !(thisReportDef.HasReportDefinition == 0 && !thisReportDef.CanSave && !thisReportDef.IsHidden)
                && !(thisReportDef.HasReportDefinition == 0 && !thisReportDef.SaveChecked && !thisReportDef.IsHidden)

            ) {
                if (thisReportDef.SaveChecked) {
                    thisReportDef.CanSave = true;
                }
                else {
                    thisReportDef.CanSave = false;
                }

                if (thisReportDef.HideChecked) {
                    thisReportDef.IsHidden = true;
                }
                else {
                    thisReportDef.IsHidden = false;
                }

                // now we need to determine if this component needs to be marked as isDirty

                // first we will look at new definitions to be saved

                if (!this.isDirty && thisReportDef.HasParameterValueDefined == 0 && thisReportDef.SaveChecked) {

                    if (this.isDistrictDefinitions && thisReportDef.IsDistrictDefinedParameter) {
                        this.isDirty = true;

                        if (this.inDebugMode) {
                            console.log('isDirty');
                            console.log(thisReportDef);
                        }
                    }
                    else if (!this.isDistrictDefinitions && thisReportDef.IsUserDefinedParameter) {
                        this.isDirty = true;
                        if (this.inDebugMode) {
                            console.log('isDirty');
                            console.log(thisReportDef);
                        }
                    }
                }

                // now we will look at existing definitions that have been unchecked to save

                if (!this.isDirty && thisReportDef.HasParameterValueDefined == 1 && !thisReportDef.SaveChecked) {

                    if (this.isDistrictDefinitions && thisReportDef.IsDistrictDefinedParameter) {
                        this.isDirty = true;
                        if (this.inDebugMode) {
                            console.log('isDirty');
                            console.log(thisReportDef);
                        }
                    }
                    else if (!this.isDistrictDefinitions && thisReportDef.IsUserDefinedParameter) {
                        this.isDirty = true;
                        if (this.inDebugMode) {
                            console.log('isDirty');
                            console.log(thisReportDef);
                        }
                    }
                }




                // // set the value coming from the report parameters page
                // if (thisReportDef.CanSave) {
                //     for (let p = 0; p < this.selectedReport.Parameters.length; p++) {
                //         if (this.selectedReport.Parameters[p].ParameterReportDefinition.ParameterName_ID == thisReportDef.ParameterName_ID) {
                //             thisReportDef.Value = this.selectedReport.Parameters[p].Value;
                //         }
                //     }
                // }


                // handle district parameters
                // this.selectedReport.IsDistrictReportDefinitions
                if (this.isDistrictDefinitions && thisReportDef.IsDistrictDefinedParameter) {
                    parameterDefinitions.push(thisReportDef);
                }

                //  handle user parameter definitions
                // this.selectedReport.IsDistrictReportDefinitions
                if (!this.selectedReport.IsDistrictReportDefinitions && !thisReportDef.IsDistrictDefinedParameter && (thisReportDef.SaveChecked || thisReportDef.HideChecked)) {
                    thisReportDef.Login_ID = this.reportService.login_ID;
                    parameterDefinitions.push(thisReportDef);
                }

            }

        }

        return parameterDefinitions;


        // if (this.isDirty) {

        //     // need to save any changes
        //     this.reportService.saveReportOptions(parameterDefinitions, true).subscribe(saveWasSuccessful => {

        //         // if (this.reportService.inDebugMode) {
        //         //     console.log('saveWasSuccessful: ' + saveWasSuccessful);
        //         //     console.log(parameterDefinitions);
        //         // }

        //         // close after save
        //         this.thisDialogRef.close(this.isDirty);

        //     });

        // }
        // else { // NO need to save any changes
        //     this.thisDialogRef.close(this.isDirty);
        // }



    }

    isDisabled(reportDef: ReportDefinition) {
        let isDisabled = false;
        // disable user parameters where there is a district override
        if (!this.isDistrictDefinitions && reportDef.IsDistrictDefinedParameter && reportDef.HasParameterValueDefined == 1) {
            isDisabled = true;
        }
        // if (reportDef.HideChecked) {
        //     isDisabled = true;
        // }
        return isDisabled;
    }

    isSaveDisabled(reportDef: ReportDefinition) {
        let isDisabled = false;
        // disable user parameters where there is a district override
        if (!this.isDistrictDefinitions && reportDef.IsDistrictDefinedParameter && reportDef.HasParameterValueDefined == 1) {
            isDisabled = true;
        }
        if (reportDef.HideChecked) {
            isDisabled = true;
        }
        return isDisabled;
    }

    IsDistrictReportDefinitionsChanged(event: MatRadioChange) {

        // this.selectedReport.IsDistrictReportDefinitions = !this.selectedReport.IsDistrictReportDefinitions;

        // if (this.reportService.inDebugMode) {
        //     // console.log('IsDistrictReportDefinitionsChanged()');
        //     console.log(event.value);
        //     // console.log('this.selectedReport.IsDistrictReportDefinitions');
        //     // console.log(this.selectedReport.IsDistrictReportDefinitions);
        // }

        if (event.value == 'true') {
            this.isDistrictDefinitions = true;
            this.selectedReport.IsDistrictReportDefinitions = true;
        }
        else {
            this.isDistrictDefinitions = false;
            this.selectedReport.IsDistrictReportDefinitions = false;
        }
        //  we need to reload the report for appropriate saved report defs

        // this.selectedReport.GetSelectedReportDefintionsOnly = false;

        this.getReportDefinitions();

        // this.selectedReport.Parameters.length = 0;
        // this.selectedReport.ReportDefinitions.length = 0;


        // this.reportService.getReportParameters(-1, this.selectedReport).subscribe(report => {
        //   this.selectedReport = report; //  update the local reference
        // });


    }

    setBackgroundColorForSavedDefinition(repDef: ReportDefinition) {
        if (repDef.HideChecked || repDef.SaveChecked) {
            if (repDef.IsDistrictDefinedParameter) {
                repDef.BackgroundColorForSavedDefinition = this.reportService.backgroundColorForDistrictDefinedDefinition;
            }
            else if (repDef.IsUserDefinedParameter) {
                repDef.BackgroundColorForSavedDefinition = this.reportService.backgroundColorForUserDefinedDefinition;
            }
        }
        else {
            repDef.BackgroundColorForSavedDefinition = null;
        }
    }

    defintionsToConsole() {
        console.log(this.reportDefinitions);
        console.log('IsDirty: ' + this.isDirty);
    }

    selectedReportToConsole() {
        console.log(this.selectedReport);
    }

    // folderDeleteClick(folder: ReportFolder) {
    //     this.reportService.reportFolderIdToDelete = folder.Id;
    //     this.reportService.reportFolderNameToDelete = folder.Name;
    //     this.deleteReportFolderDialogRef = this.deleteReportFolderDialog.open(DeleteReportFolderComponent, {
    //         panelClass: 'tyl-mat-dialog',
    //         disableClose: true
    //     });

    //     this.deleteReportFolderDialogRef.afterClosed().subscribe(result => {

    //         if (this.reportService.inDebugMode) {
    //             console.log('deleteReportFolderDialogRef.afterClosed()');
    //         }

    //         if (result == true) {
    //             // we need to refresh report folders

    //             this.getMyReportFolders();
    //         }

    //     });
    // }

    // addFolderClick() {

    //     this.addReportFolderDialogRef = this.addReportFolderDialog.open(AddReportFolderComponent, {
    //         panelClass: 'tyl-mat-dialog',
    //         disableClose: true
    //     });

    //     this.addReportFolderDialogRef.afterClosed().subscribe(result => {

    //         if (this.reportService.inDebugMode) {
    //             console.log('addReportFolderDialogRef.afterClosed()');
    //         }

    //         if (result == true) {
    //             // we need to refresh report folders

    //             this.getMyReportFolders();
    //         }

    //     });


    // }

    // getMyReportFolders(): void {
    //     this.reportService.getMyReportFolders().subscribe(folders => {
    //         this.reportFolders = folders;
    //         this.reportService.ReportFolders = this.reportFolders;

    //     });
    // }


    // closeClick() {
    //     // this.getMyReportFolders();
    //     this.thisDialogRef.close(this.isDirty);
    // }


    // saveFolderReports(selectedFolderIds: number[]) {

    //     // // we need to save the report folders
    //     // this.reportService.saveFolderReports(this.reportService.login_ID, this.selectedReport.Id, selectedFolderIds).subscribe(results => {
    //     //     this.thisDialogRef.close('Folders Saved');
    //     // });
    // }

    legendClick() {
        this.reportLegendDialogRef = this.reportLegendDialog.open(ReportLegendComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

    }

    howToClick() {
        this.howToDialogRef = this.howToDialog.open(ReportOptionsHowToComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });
    }


}